import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Input, Button, Spin, Select } from 'antd';
import { AuthWrapper } from '../../style';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { pushKyc,updateNameAndNric } from '../../../../../../redux/authentication/actionCreator';
import ReactGA from 'react-ga';
import api from '../../../../../../redux/authentication/api';
import e from 'cors';
import './ButtonStyles.scss';

function EKYCNameAndNicUpdate() {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const title = useSelector(state => state.auth.title)
  const referenceId = useSelector(state => state.auth.dataForm.referenceId)
  const dispatch = useDispatch();
  const msisdn = useSelector(state => state.auth.dataForm.msisdn);
  const isLoading = useSelector(state => state.auth.loading);
  const [form] = Form.useForm();
  const url = window.location.href;
  //const url="https://kongsi-portal-dev.s3-website-ap-southeast-1.amazonaws.com/signup";
  const CALL_BACK_API_URL = process.env.REACT_APP_CALL_BACK_API_URL;
  const nricPattern = /^\d{6}-\d{2}-\d{4}$/;

  useEffect(() => {
    const getUserByRfId = async () => {
      if (!userDetails) {
        let data = await api.get('/query/profile/referenceId?referenceId='+referenceId);
        setLoading(false);
        setUserDetails(data.data);
      }
    };
    getUserByRfId();
  }, [setUserDetails]);

  const handleSubmit = values => {
    ReactGA.event({ category: 'Kongsi Klub ekyc Name&NIC update', action: 'Enter Details' });
    const params = {
      clientCode: 'REFERRAL',
      referenceId: referenceId,
      name: values.name,
      idType: 'NRIC',
      idNumber: values.nric,
      age: userDetails.age,
    };
    dispatch(updateNameAndNric(params, true));
  };

  if (!loading&&userDetails!==null) {
    return (
      <AuthWrapper>
        <div className="auth-contents">
          <Form name="register" onFinish={handleSubmit} layout="vertical" form={form}>
            <Heading as="h4">
            Nama / Nombor Kad Pengenalan Tidak Sepadan[{title}] &nbsp;
            </Heading>
            <p>Sila sahkan nama dan nombor kad pengenalan anda supaya sepadan dengan butiran MyKad anda.</p>
            <Form.Item
              label="Nombor NRIC"
              name="nric"
              initialValue={ nricPattern.test(userDetails.nric)
                ? userDetails.nric
                : userDetails.nric.replace(/(\d{6})(\d{2})(\d{4})/, '$1-$2-$3')}
              rules={[
                { required: true, message: 'Nombor IC diperlukan' },
                { pattern: nricPattern, message: 'Format Nombor IC 000000-00-0000' },
              ]}
            >
              <Input placeholder={"000000-00-0000"} />
            </Form.Item>
            <Form.Item
              label="Nama mengikut MyKad anda"
              name="name"
              initialValue={userDetails.preferredName}
              rules={[{ required: true, message: 'Nama Seperti di MyKad diperlukan' }]}
            >
              <Input placeholder="Nama Seperti di MyKad" />
            </Form.Item>

            <Form.Item>
              <Button className="btn-create" htmlType="submit" type="primary" size="large" disabled={isLoading}>
              Sahkan
              </Button>
            </Form.Item>
          </Form>
        </div>
      </AuthWrapper>
    );
  }
  return null;
}

export default EKYCNameAndNicUpdate;
